import { Button, ButtonProps } from '@/shared/ui/Button'

export interface ShareLinkProps extends ButtonProps {
	ref?: React.RefObject<HTMLButtonElement>
	text: string
	icon: React.ReactNode
	onShare: () => void
}

export const ShareLink = ({
	ref,
	text,
	icon,
	onShare,
	...props
}: ShareLinkProps) => {
	return (
		<Button
			ref={ref}
			className="h-6 p-0 font-normal"
			variant="flat"
			onClick={onShare}
			{...props}
		>
			{icon} {text}
		</Button>
	)
}
ShareLink.displayName = 'ShareLink'
